import { IBaseApiResponse } from '@/typescript/interfaces/common.interface';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@services/auth/token.service';
import { SharedService } from '@services/shared/shared.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
interface AuctionModifyDataProps {
  present: any[];
}

export interface IUserDetails {
  first_name: string;
  last_name?: any;
  email: string;
  phone?: string;
  profileImage: {
    presigned_url: string;
    media_name: string;
  };
  total_rows: string;
}

export interface IParticipentsData {
  auto_bid_id: string;
  auction_id: string;
  user_id: string;
  auto_bid: string;
  created_at: string;
  updated_at: string;
  auction_bidding_point: string;
  status: string;
  email_sent: string;
  userDetails: IUserDetails[];
}

export interface IParticipentsListResponse extends IBaseApiResponse {
  data: IParticipentsData[];
}
export interface IOnlineIndividualsResponse extends IBaseApiResponse {
  data: IUserDetails[];
}

type TParams = NonNullable<Parameters<HttpClient['get']>['1']>['params'];

@Injectable({
  providedIn: 'root',
})
export class AuctionService {
  public getLiveBids: BehaviorSubject<any> = new BehaviorSubject(null);

  // These live in the SERVICE so the component can react to changes(online individuals)
  private itemsSubject = new BehaviorSubject<IUserDetails[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private hasMoreSubject = new BehaviorSubject<boolean>(true);

  // Components subscribe to these
  items$ = this.itemsSubject.asObservable();
  loading$ = this.loadingSubject.asObservable();
  hasMore$ = this.hasMoreSubject.asObservable();

  constructor(
    public http: HttpClient,
    private _token: TokenService,
    private _sharedService: SharedService
  ) {}

  private getLimitFromParams(params: TParams): number | null {
    if (!params) return null;

    // if (params instanceof HttpParams) {
    //   const limit = params.get('limit');
    //   const parsed = limit == null ? NaN : Number(limit);
    //   return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    // }

    const maybeRecord = params as unknown as Record<string, unknown>;
    const rawLimit = maybeRecord['limit'];
    const parsed = rawLimit == null ? NaN : Number(rawLimit);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  set setLiveBids(value: any) {
    this.getLiveBids.next(value);
  }

  /**
   * Auction api implementations
   */

  addAuction(auction_data: Object) {
    const URL = `${environment.api}auctions/add`;

    return this.http.post(URL, auction_data, {
      headers: this._token.getTokenHeader(),
    });
  }

  // edit auction (from time-individual: Oct 23)

  editAuction(auction_data: Object) {
    // const URL = `${environment.v4}update/auction`;
    const URL = `${environment.v4}update/auction`;

    return this.http.post(URL, auction_data, {
      headers: this._token.getTokenHeader(),
    });
  }

  endAuction(auction_id: string) {
    const URL = `${environment.v4}timed/auction/end/${auction_id}`;

    return this.http.get(URL, {
      headers: this._token.getTokenHeader(),
    });
  }
  endBulkAuction(auction_id: string) {
    const URL = `${environment.v4}bulk/auction/end/${auction_id}`;

    return this.http.get(URL, {
      headers: this._token.getTokenHeader(),
    });
  }

  getAuctionList(pageNo: number = 1) {
    const URL = `${environment.api}auctions/list`;
    console.log('getAuctionList');
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: {
          page: pageNo,
          limit: 10,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getIndividualAuction(): Observable<any> {
    const URL = `${environment.api}auctions/list`;
    console.log('getIndividualAuction');
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: {
          page: 1,
        },
      })
      .pipe(map((result: any) => result));
  }

  getIndividualBatchAuction(pageNo: number = 1) {
    const URL = `${environment.api}auctions/batch/list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: {
          page: pageNo,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getBatchAuctionList(): Observable<any> {
    const URL = `${environment.api}auctions/batch/list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  // 2nd
  getGroupAuctionList(): Observable<any> {
    const URL = `${environment.api}auctions/group/list`;

    return this.http.get(URL, { headers: this._token.getTokenHeader() });
  }

  deleteAuction(auctionId: string) {
    const URL = `${environment.api}auctions/delete/${auctionId}`;

    return this.http.delete(URL, { headers: this._token.getTokenHeader() });
  }

  getEditAuctionData(auction_id: any) {
    // const URLDev = `${environment.v4}auction/edit/${auction_id}`;
    const URLStage = `${environment.api}auctions/edit/${auction_id}`;

    return this.http
      .get(URLStage, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  AllAuctionStatus() {
    const URL = `${environment.api}total/auction/list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  auctionBulkAdd(auction_bulkData: Object) {
    const URL = `${environment.api}auctions/bulk/add`;

    return this.http
      .post(URL, auction_bulkData, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getCityList(city_list_data: Object) {
    const URL = `${environment.api}/user/city/list`;

    return this.http
      .post(URL, city_list_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  auctionLiveBiddingHistory(auction_id: any): any {
    const URL = `${environment.api}live/auction/bidding-history/list/${auction_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  //

  auctionParticipentsList(auction_id: string) {
    const URL = `${environment.v4}auction/participate/list/${auction_id}`;

    return this.http
      .get<IParticipentsListResponse>(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  auctionListPagination() {
    const URL = `${environment.api}auctions/listt`;
    let getNextPageNum = JSON.parse(localStorage.getItem('nextPageNumber'));
    console.log('auctionListPagination');
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: {
          page: getNextPageNum,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  public auctionListItems: AuctionModifyDataProps = {
    present: [],
  };

  getAuctionModifyData(data: any[]): AuctionModifyDataProps {
    const curretDate: number = new Date().getTime();
    if (!data.length) {
      return this.auctionListItems;
    }
    data.forEach((auction: Record<any, any>) => {
      if (auction['live_start_date_time'] || auction['live_end_date_time']) {
        const liveStrt: number = new Date(
          auction['live_start_date_time']
        ).getTime();
        const liveEnd: number = new Date(
          auction['live_end_date_time']
        ).getTime();
        // current auction
        if (auction['imageUrl']) {
          auction = {
            ...auction,
            image: auction['imageUrl'][0]['presigned_url'],
          };
        } else if (auction['vehicle_images']) {
          auction = {
            ...auction,
            image:
              environment.imgBaseUrl +
              auction['vehicle_images']['parts_images'].filter(
                (item: any) => item['part_name'] === 'Front'
              )?.[0]['image'],
          };
        }

        if (auction['entity_type'] !== 'group' && auction['description_data']) {
          auction = {
            ...auction,
            car_name: this._sharedService.InventoryName(
              auction['description_data']
            ),
          };
        } else {
          auction = {
            ...auction,
            car_name: `${auction['title']}`,
          };
        }

        if (liveStrt <= curretDate && curretDate <= liveEnd) {
          this.auctionListItems.present.push(auction);
        }
      }
    });

    return this.auctionListItems;
  }

  updateStatus(auctionId: string, status: string) {
    // const URLDev = `${environment.v4}auction/edit/${auctionId}`;
    const URLStage = `${environment.api}auctions/edit/${auctionId}`;

    return this.http
      .get(URLStage, {
        headers: this._token.getTokenHeader(),
        params: { approve: status },
      })
      .pipe(map((result) => result));
  }

  getPurchaseList(nextPage: number = 1) {
    // const URL = `${environment.payment_api}payment/list`
    const URL = `${environment.recycleApi}payment/list`;
    return this.http.get(URL, {
      headers: this._token.getTokenHeader(),
      params: {
        page: nextPage,
        limit: 15,
      },
    });
  }

  updatePaymentStatus(productId: string, paymentStatus: object) {
    const URL = `${environment.payment_api}payment/status/${productId}`;

    return this.http.post(URL, paymentStatus, {
      headers: this._token.getTokenHeader(),
    });
  }

  auctionAuthenticationCheck(authParams: object) {
    const URL = `${environment.authCheck_api}auth/login`;
    return this.http.post(URL, authParams);
  }

  dmsLogin() {
    const payload = {
      email_username: environment.vamId,
      password: environment.vamPassword,
    };

    const URL = `${environment.authCheck_api}auth/login`;
    return this.http.post(URL, payload);
  }

  updateDocStatus(auctionId: string, payload: object) {
    const URL = `${environment.recycleApi}auction/payment/doc/status/${auctionId}`;

    return this.http.post(URL, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  markVehiclesAsReserveAndSold(dmsAccessToken: string, payload: object) {
    const url = `${environment.authCheck_api}car/auction-vehicle/status-bulk`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${dmsAccessToken}`,
    });

    return this.http.post(url, payload, { headers: headers });
  }

  vehicleStatusCheck(vehicleParams: object) {
    const URL = `${environment.authCheck_api}car/auction-vehicle/status`;
    let auctionToken = JSON.parse(localStorage.getItem('auctionUser'));

    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auctionToken['token']}`, //auctionToken['token'],
    });
    return this.http.post(URL, vehicleParams, {
      headers: header,
      observe: 'response' as 'response',
    });
    //     .pipe(map(data => {
    //  return data.httpStatus
    //    }));
  }

  uploadAuctionInvoice(auctionId: string, payload: object) {
    const URL = `${environment.recycleApi}auction/invoice/create/${auctionId}`;

    return this.http.post(URL, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  getAuctionInvoice(auctionId: string) {
    const URL = `${environment.recycleApi}auction/invoice/view/${auctionId}`;

    return this.http.get(URL);
  }

  deleteAuctionInvoice(auctionId: string, payload: object) {
    const URL = `${environment.recycleApi}auction/invoice/delete/${auctionId}`;

    return this.http.post(URL, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  retailSearch(payload: object, nextPage: number = 1) {
    const URL = `${
      environment.newInventoryApi
    }inventory/payment/search?page=${nextPage}&limit=${15}`;
    return this.http.post(URL, payload);
  }

  getFilteredAuction(payload: object) {
    const URL = `${environment.pdiAPI}auction/filter`;

    return this.http.post(URL, payload);
  }

  getIndividualFilteredAuction(payload: object, pageNo: number = 1) {
    const URL = `${
      environment.pdiAPI
    }auction/filter/list?page=${pageNo}&limit=${10}`;

    return this.http.post(URL, payload);
  }

  getBulkFilteredAuction(payload: object, pageNo: number = 1) {
    const URL = `${environment.pdiAPI}auction/filter/group/list`;

    return this.http.post(URL, payload);
  }

  getIndividualBatchFilteredAuction(payload: object, pageNo: number = 1) {
    const URL = `${environment.pdiAPI}auction/filter/batch/list`;

    return this.http.post(URL, payload);
  }

  prepareIndividualAuctionTableData(auctions: object[]) {
    const preparedData = auctions.map((auction) => {
      return {
        Photo: auction['vehicle_images']
          ? environment.imgBaseUrl +
            auction['vehicle_images']?.['parts_images'].filter(
              (part) => part.part_name === 'Front'
            )?.[0]?.['image']
          : environment.forntend_url + 'assets/img/car-placeholder.png',
        Make: auction['description_data']['Make'],
        Model: auction['description_data']['Model'],
        'Trim/Type': auction['description_data']['Trim/Type'],
        'Model Year': auction['description_data']['Model Year'],
        VIN: auction['description_data']['VIN Number'],
        Registration: auction['description_data']['Plate Number'],
        ODO: auction['description_data']['ODO'],
        'Exterior colour':
          auction['description_data']['Exterior Colour'] || '--',
        'Interior colour':
          auction['description_data']['Interior Colour'] || '--',
        'Engine CC': auction['description_data']['CC'] || '--',
        Gears: auction['description_data']?.['Gear'] || '--',
        'Reserved price': auction['lowest_price'] || '--',
        'Buy now price': auction['buy_now_price'] || '--',
        'Highest bid': auction?.['HighestBid'] || '--',
        'Auction start date':
          this.formatDate(auction?.['live_auction_start_date_time']) || '--',
        'Auction end date':
          this.formatDate(auction?.['live_auction_end_date_time']) || '--',
        Accleration: auction['description_data']?.['Accleration'] || '--',
        'Assessment type':
          auction['description_data']?.['Assessment Type'] || '--',
        'Body type': auction['description_data']?.['Body Type'] || '--',
        COD: auction['description_data']?.['COD'] || '--',
        Condition: auction['description_data']?.['Condition'] || '--',
        Cylinders: auction['description_data']?.['Cylinders'] || '--',
        Doors: auction['description_data']?.['Doors'] || '--',
        'Drive type': auction['description_data']?.['Drive Type'] || '--',
        'Engine type': auction['description_data']?.['Engine Type'] || '--',
        Estimara: auction['description_data']?.['Estimara'] || '--',
        'Estimara expiry date':
          auction['description_data']?.['Estimara expiry date'] || '--',
        'Finance status':
          auction['description_data']?.['Finance Status'] || '--',
        'Fuel type': auction['description_data']?.['Fuel Type'] || '--',
        'HP (Horse Power)':
          auction['description_data']?.['HP (Horse Power)'] || '--',
        'Last service date':
          auction['description_data']?.['Last service date'] || '--',
        'Last service kilometers':
          auction['description_data']?.['Last service kilometers'] || '--',
        'MVPI expiry date':
          auction['description_data']?.['MVPI expiry date'] || '--',
        'Max Speed': auction['description_data']?.['Max Speed'] || '--',
        Mileage: auction['description_data']?.['Mileage'] || '--',
        Origin: auction['description_data']?.['Origin'] || '--',
        Ownership: auction['description_data']?.['Ownership'] || '--',
        Seat: auction['description_data']?.['Seat'] || '--',
        'Service and maintenance status':
          auction['description_data']?.['Service and maintenance status'] ||
          '--',
        Torque: auction['description_data']?.['Torque'] || '--',
        'Transmission type':
          auction['description_data']?.['Transmission Type'] || '--',
        Upholstery: auction['description_data']?.['Upholstery'] || '--',
        'Utility type': auction['description_data']?.['Utility Type'] || '--',
        'Vehicle type': auction['description_data']?.['Vehicle Type'] || '--',
        Vendor: auction['description_data']?.['Vendor'] || '--',
        Warranty: auction['description_data']?.['Warranty'] || '--',
        'Warranty expiry date':
          auction['description_data']?.['Warranty expiry date'] || '--',
        'Wheel Base': auction['description_data']?.['Wheel Base'] || '--',
        Recycle:
          auction?.['recycle'] === '0' ? 'Fresh' : auction?.['recycle'] || '--',
        Actions: {
          auctionId: auction?.['auction_id'],
          isDisable: auction?.['approval'] && auction?.['lock_status'],
        },
      };
    });

    return preparedData;
  }

  formatDate(inputDate: string) {
    let [datePart, timePart] = inputDate.split(', ');
    timePart = timePart.slice(0, 5) + timePart.slice(-3);
    let newDateTimeString = `${timePart}, ${datePart}`;

    return newDateTimeString;
  }

  prepareBulkAuctionTableData(auctions: object[]) {
    const preparedData = auctions.map((auction) => {
      return {
        Photo:
          auction['bulkInfo']?.[0]?.['BatchImageUrl']?.[0]?.['presigned_url'],

        Title: auction?.['title'] || '--',
        'Start date':
          this.formatDate(auction?.['live_auction_start_date_time']) || '--',
        'End date':
          this.formatDate(auction?.['live_auction_end_date_time']) || '--',
        'Total vehicles':
          auction['bulkInfo']?.[0]?.['ProductInfo']?.length || '--',
        'Highest bid': auction?.['HighestBid'] || '--',
        Recycle:
          auction?.['recycle'] === '0' ? 'Fresh' : auction?.['recycle'] || '--',
        Actions: {
          auctionId: auction?.['auction_id'],
          auctionName: auction?.['title'],
          isDisable: auction?.['approval'] && auction?.['lock_status'],
          vehicleIds: auction?.['bulkInfo']?.[0]?.['ProductInfo']
            ?.map((vehicle) => vehicle?.['options']?.['vehicle_id'])
            .join(','),
        },
      };
    });

    return preparedData;
  }

  prepareBatchAuctionTableData(auctions: object[]) {
    const preparedData = auctions.map((auction) => {
      return {
        Photo: auction['BatchImageUrl']?.[0]?.['presigned_url'],
        Title: auction?.['title'] || '--',
        Id: auction?.['id'] || '--',
        Description: auction?.['description'] || '--',
        'Group name': auction?.['group_name'] || '--',
        'Total vehicles': auction?.['ProductInfo']?.length || '--',
        Location: auction?.['location'] || '--',
        'Highest bid': auction?.['HighestBid'] || '--',
        Recycle:
          auction?.['recycle'] === '0' ? 'Fresh' : auction?.['recycle'] || '--',
        Actions: {
          auctionId: auction?.['auction_id'],
          isDisable: auction?.['approval'] && auction?.['lock_status'],
        },
      };
    });

    return preparedData;
  }

  dmsLoginService() {
    const credential = {
      email_username: environment.vamId,
      password: environment.vamPassword,
    };

    const URL = `${environment.authCheck_api}auth/login`;
    return this.http.post(URL, credential);
  }

  pdfGenerateRequest(payload: object, dmsAccessToken: string) {
    return this.http.post(
      `${environment.authCheck_api}generate/requested-pdfs`,
      payload,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer' + dmsAccessToken,
        }),
      }
    );
  }

  isReportGenerated(auctionId: string) {
    return this.http.post(
      `${environment.pdiAPI}pdf/fetch`,
      { auction_id: auctionId },
      { headers: this._token.getTokenHeader() }
    );
  }

  /**
   * Infinite-scroll loader with internal state (items$, loading$, hasMore$).
   * This intentionally subscribes internally and returns void.
   */
  auctionOnlineIndividualsList(auction_id: string, params: TParams): void {
    const URL = `${environment.v4}auction/visitor/${auction_id}`;

    if (this.loadingSubject.value) return; // prevent duplicate calls

    this.loadingSubject.next(true);

    const requestedLimit = this.getLimitFromParams(params) ?? 10;

    this.http
      .get<IOnlineIndividualsResponse>(URL, {
        headers: this._token.getTokenHeader(),
        params,
      })
      .pipe(
        finalize(() => this.loadingSubject.next(false)) // always runs, even on error
      )
      .subscribe({
        next: (response) => {
          if ((response?.data?.length ?? 0) < requestedLimit) {
            // Less than the requested limit means it's the last page.
            this.hasMoreSubject.next(false); // 🛑 tell everyone: no more data
          }

          const currentItems = this.itemsSubject.value;
          this.itemsSubject.next([...currentItems, ...response?.data]);
        },
        error: (err) => {
          console.error('Failed to load auction individuals', err);
        },
      });
  }

  auctionSold(auctionId: string) {
    const url = `${environment.v5}auction/sold/${auctionId}`;

    return this.http.get<IBaseApiResponse>(url, {
      headers: this._token.getTokenHeader(),
    });
  }

  // Call this when you want to reset (e.g. new auction_id)
  resetItems(): void {
    this.itemsSubject.next([]);
    this.hasMoreSubject.next(true);
  }
}
